<script lang="ts">
	//UI
	import { Calendar } from "@hitit/new_ui/src";
	//Image
	import CalendarImg from "@hitit/hub/src/assets/Icons/Calendar.png";

	//Utils
	import moment from "moment";
	import { clickOutside } from "@hitit/hub/src/v7/utils";
	import { onDestroy, onMount } from "svelte";
	export let range = {
		start: new Date(),
		end: new Date(),
	};

	export let showCalendar = false;
	let left = true;
	let timeoutRef: any;
	let container: HTMLDivElement;

	$: calendarPosition = left ? `left : 0` : `right : 0`;

	onMount(() => {
		left = calculateCalendarPosition();

		window.addEventListener("resize", resizingHandler);
	});

	onDestroy(() => {
		window.removeEventListener("resize", resizingHandler);
	});

	function calculateCalendarPosition() {
		const innerWidth = window.innerWidth;
		const containerLocation = container.getBoundingClientRect();
		const left = containerLocation.left;
		return left + 350 < innerWidth;
	}

	function resizingHandler() {
		if (timeoutRef) {
			clearTimeout(timeoutRef);
		}

		timeoutRef = setTimeout(() => {
			left = calculateCalendarPosition();
		}, 100);
	}

	function calendarOutsideCallback() {
		showCalendar = false;
	}
</script>

<div class="container" bind:this={container}>
	<div class="range-wrapper" on:click={() => (showCalendar = !showCalendar)}>
		<img src={CalendarImg} alt="open calendar" />
		<div>
			<span>{moment(range.start).format("yyyy.MM.DD")}</span>
			<span>-</span>
			<span>{moment(range.end).format("yyyy.MM.DD")}</span>
		</div>
	</div>
	{#if showCalendar}
		<div class="calendar-wrapper" style={calendarPosition}>
			<Calendar
				on:change
				rangeMode
				range={range}
				action={clickOutside(calendarOutsideCallback)}
			/>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	div {
		box-sizing: border-box;
	}
	.container {
		position: relative;
		z-index: 99;
		display: flex;
		align-items: center;
		height: 32px;
		width: 230px;
	}

	.range-wrapper {
		display: flex;
		align-items: center;
		gap: 10px;

		&:hover {
			cursor: pointer;
		}

		img {
			width: 30px;
			height: 31px;
		}

		span {
			color: #46474b;
			font-weight: 550;
		}
	}
	.calendar-wrapper {
		position: absolute;
		top: 42px;
	}

	@include DesktopSize {
		.container {
			height: 40px;
			font-size: 1.25rem;
			width: 300px;
		}
	}
</style>
